import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app.mjs';
import { BrowserRouter } from "react-router-dom";


const root = ReactDOM.createRoot(document.getElementById('app-root'));
root.render(
  <BrowserRouter>
    <React.StrictMode>
      <App></App>
    </React.StrictMode>
  </BrowserRouter>
);
